import React from 'react';
import './NotFound.css';

function NotFound() {
    return (
        <section id="not-found" className="not-found">
        <h2>404 - Page Not Found</h2>
        <p>Sorry, the page you are looking for does not exist.</p>
        <button onClick={() => window.location.href = '/'}>Back to Home</button>
        </section>
    );
}

export default NotFound;